import React, { useEffect, useState } from "react";
import axios from "axios";

const SiteSettings = () => {
  const token = localStorage.getItem("token");
  const [form, setForm] = useState({});
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("info");

  const fields = [
    { key: "inactive_weeks", label: "Кількість тижнів до неактивності" },
    { key: "default_returnVat", label: "Повернення VAT" },
    { key: "default_taxesZus", label: "Податки ZUS" },
    { key: "default_partner", label: "Партнер" },
    { key: "default_accountant", label: "Бухгалтер" },
    { key: "default_carRent", label: "Оренда авто" },
    { key: "default_other", label: "Інше" },
    { key: "default_sallary", label: "Зарплата" },
    { key: "default_refunds", label: "Повернення коштів" },
  ];

  useEffect(() => {
    axios
      .get("https://godrive.com.pl/api/settings", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setForm(res.data))
      .catch(() => {
        setMessage("Помилка завантаження налаштувань");
        setMessageType("danger");
      });
  }, []);

  const handleSave = () => {
    axios
      .post("https://godrive.com.pl/api/settings", form, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        setMessage("Налаштування успішно збережено ✅");
        setMessageType("success");
      })
      .catch((error) => {
        if (error.response?.status === 403) {
          setMessage("У вас немає доступу ❌");
        } else {
          setMessage("Помилка збереження ❌");
        }
        setMessageType("danger");
      });
  };

  return (
    <div className="container py-4">
      <div className="card shadow-sm">
        <div className="card-body">
          <h3 className="card-title mb-4">Налаштування сайту</h3>

          {fields.map(({ key, label }) => (
            <div className="mb-3" key={key}>
              <label htmlFor={key} className="form-label">
                {label}:
              </label>
              <input
                type="number"
                className="form-control"
                id={key}
                min="0"
                value={form[key] || ""}
                onChange={(e) =>
                  setForm((prev) => ({ ...prev, [key]: e.target.value }))
                }
              />
            </div>
          ))}

          <button className="btn btn-primary" onClick={handleSave}>
            Зберегти
          </button>

          {message && (
            <div className={`alert alert-${messageType} mt-4`} role="alert">
              {message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};


export default SiteSettings;
